export const DEFAULT_GEO = {
    city: 'Irvine',
    state: 'CA',
    coordinates: {
        latitude: 33.6846,
        longitude: -117.8265,
    },
};
export const showcaseListingsFlag = 'fe.resi.marketing-showcase-listings';
export const showcasePropertiesFlag = 'fe.resi.marketing-showcase-properties';
export const FEATURE_FLAGS_NEEDED = [
    'fe.resi.search.private-seller-enabled',
    'fe.resi.enable-private-seller',
    'fe.resi.is-buyer-dashboard-menu-item-enabled',
    'fe.resi.enable-private-seller-dashboard-dropdown-menu',
    'fe.resi.enable-wallet',
    'fe.resi.sell-link-enabled',
    showcaseListingsFlag,
    showcasePropertiesFlag,
];
export const DEFAULT_FLAGS = {
    'fe.resi.search.private-seller-enabled': true,
    'fe.resi.enable-private-seller': true,
    'fe.resi.is-buyer-dashboard-menu-item-enabled': true,
    'fe.resi.enable-private-seller-dashboard-dropdown-menu': true,
    'fe.resi.enable-wallet': true,
    'fe.resi.sell-link-enabled': true,
    [showcaseListingsFlag]: {},
    [showcasePropertiesFlag]: {},
};
export const EVENT_TYPES = {
    GEO_UPDATED: 'geoUpdated',
    CURRENT_USER_AND_FLAGS_UPDATED: 'currentUserAndFlagsUpdated',
};
